import { render, staticRenderFns } from "./AgencyList.vue?vue&type=template&id=8f28e666&"
import script from "./AgencyList.vue?vue&type=script&lang=js&"
export * from "./AgencyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports